import {
  FirestoreDataConverter,
  DocumentSnapshot,
  SnapshotOptions,
  WithFieldValue,
  Timestamp,
} from 'firebase/firestore';
import { VehicleTimeline, VehicleTimelineNote } from '../timeline';

export const vehicleTimelineConverter: FirestoreDataConverter<VehicleTimeline> = {
  toFirestore(vehicleTimeline: WithFieldValue<VehicleTimeline>) {
    const { id, ...data } = vehicleTimeline;
    return {
      vehicle_id: data.vehicle_id ?? '',
      notes: data.notes ?? [],
      updated_at: data.updated_at ?? Timestamp.now(),
    };
  },

  fromFirestore(snapshot: DocumentSnapshot, options: SnapshotOptions): VehicleTimeline {
    const data = snapshot.data(options);

    if (!data) {
      return {
        id: snapshot.id,
        vehicle_id: snapshot.id,
        notes: [],
        updated_at: Timestamp.now(),
      };
    }

    const notes = (data.notes ?? []) as VehicleTimelineNote[];

    return {
      id: snapshot.id,
      vehicle_id: data.vehicle_id ?? snapshot.id,
      notes,
      updated_at: data.updated_at ?? Timestamp.now(),
    };
  },
};
